{
  "development": {
    "label": "Sorocaba Refrescos Orbitta Dev",
    "appId": "3d0f7bdb-fe66-49fb-94e5-7dded8d3b48f",
    "accessToken": "Pk2bNctx6mEKQZXVbrmE3Ldr",
    "appEndpoint": "https://mcqbhlpk8b30t4-st1vjq1827w54.device.marketingcloudapis.com/"
  },
  "production": {
    "label": "Sorocaba Refrescos Orbitta Production",
    "appId": "6906c68f-faaf-4bc4-9cbd-aa105a5f9471",
    "accessToken": "swVbprBnCdnqe1nef0WqNqDO",
    "appEndpoint": "https://mcqbhlpk8b30t4-st1vjq1827w54.device.marketingcloudapis.com/"
  }
}
